import { ChevronRight } from 'lucide-react'
import { Link } from 'react-router-dom'
import { typeConfig, type FeedItem } from '@/types/homeFeed'

interface Props {
  item: FeedItem
}

const HomeFeedItem = ({ item }: Props) => {
  const cfg = typeConfig[item.type]
  const Icon = cfg.icon

  return (
    <Link
      to={item.ctaPath}
      className="group flex items-center gap-3 overflow-hidden rounded-2xl border border-border bg-card px-4 py-3.5 shadow-sm transition-colors hover:bg-muted/40"
      style={cfg.urgent ? { boxShadow: `inset 4px 0 0 ${cfg.color}` } : undefined}
    >
      <div
        className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl"
        style={{ background: cfg.tint }}
      >
        <Icon className="h-5 w-5" style={{ color: cfg.color }} />
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-xs font-bold uppercase tracking-wider" style={{ color: cfg.color }}>
          {cfg.label}
        </p>
        <p className="mt-0.5 line-clamp-2 text-base font-semibold leading-snug text-foreground">
          {item.title}
        </p>
        <p className="mt-0.5 truncate text-xs text-muted-foreground">{item.subtitle}</p>
      </div>
      <ChevronRight className="h-4 w-4 shrink-0 text-muted-foreground transition-colors group-hover:text-foreground" />
    </Link>
  )
}

export default HomeFeedItem
